'use client'

import CheckIcon from '@/components/icons/check'
import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import { forwardRef } from 'react'
import './checkbox.scss'

const classes = generateClassNames('checkbox', [
  'input',
  'control',
  'indicator',
])

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  function Checkbox(props, ref) {
    const { className, onChange, onCheckedChange, ...other } = props

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(event)
      onCheckedChange?.(event.target.checked)
    }

    return (
      <div className={clsx(classes.root, className)}>
        <input
          ref={ref}
          className={classes.input}
          type='checkbox'
          onChange={handleChange}
          {...other}
        />
        <span className={classes.control} />
        <span className={classes.indicator}>
          <CheckIcon />
        </span>
      </div>
    )
  }
)

export default Checkbox
